<script setup lang="ts">
import { Badge } from '@/components/ui/badge'
import { Card, CardContent } from '@/components/ui/card'
import { Progress } from '@/components/ui/progress'
import {
  ListTodo,
  Monitor,
  CalendarDays,
  FileText,
} from 'lucide-vue-next'

const props = defineProps<{
  projectName: string
  projectStatus: string
  stats: {
    totalReqs: number
    totalApps: number
    totalMeetings: number
    totalDocs: number
  }
}>()

const getStatusVariant = (status: string) => {
  const variants: Record<string, string> = {
    definition: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-300',
    in_development: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    qa: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    uat: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    production: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    maintenance: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
    completed: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300',
    on_hold: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300',
  }
  return variants[status] || variants.definition
}

const getStatusLabel = (status: string) => {
  const labels: Record<string, string> = {
    definition: 'Definicion',
    in_development: 'En Desarrollo',
    qa: 'QA',
    uat: 'UAT',
    production: 'Produccion',
    maintenance: 'Mantenimiento',
    completed: 'Completado',
    on_hold: 'En Pausa',
  }
  return labels[status] || status
}
</script>

<template>
  <Card class="border-dashed">
    <CardContent class="p-3">
      <div class="flex items-center justify-between mb-2">
        <p class="text-sm font-medium truncate">{{ projectName }}</p>
        <Badge :class="getStatusVariant(projectStatus)" class="text-[10px] shrink-0">
          {{ getStatusLabel(projectStatus) }}
        </Badge>
      </div>
      <div class="grid grid-cols-2 gap-2">
        <div class="flex items-center gap-1.5 text-xs text-muted-foreground">
          <ListTodo class="h-3.5 w-3.5" />
          <span>{{ stats.totalReqs }} reqs</span>
        </div>
        <div class="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Monitor class="h-3.5 w-3.5" />
          <span>{{ stats.totalApps }} apps</span>
        </div>
        <div class="flex items-center gap-1.5 text-xs text-muted-foreground">
          <CalendarDays class="h-3.5 w-3.5" />
          <span>{{ stats.totalMeetings }} reuniones</span>
        </div>
        <div class="flex items-center gap-1.5 text-xs text-muted-foreground">
          <FileText class="h-3.5 w-3.5" />
          <span>{{ stats.totalDocs }} docs</span>
        </div>
      </div>
    </CardContent>
  </Card>
</template>
